import React, { useState, useEffect } from "react";
import { Edit2, Trash2 } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import {
  updateTransaction,
  getMonthlyTransactionData,
  getLastThreeMonthsTransactionData,
  getYearlyTransactionData,
  deleteTransactions,
  getAllSearchTransactions
} from "../../../store/engagementMetricsSlice";

const optionsList = [
  { value: "All", label: "All" },
  { value: "Success", label: "Success" },
  { value: "Pending", label: "Pending" },
  { value: "Failed", label: "Failed" },
];

export default function TransactionsTabl({ filter }) {
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [editableRowData, setEditableRowData] = useState(null);
  const [isEditDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(optionsList[0]);
  const [searchQuery, setSearchQuery] = useState("");
  const [viewMode, setViewMode] = useState("filter");
  const [searchResults, setSearchResults] = useState([]);
  const dispatch = useDispatch();
  const { transactions } = useSelector((state) => state.engagementMetrics);
  const userId = useSelector((state) => state.auth.id);
  const user = useSelector((state) => state.auth.userDetails.userDetails);
  const supplier = useSelector((state) => state.auth.selectedSupplier);

  const handleUpdateTransaction = async () => {
    const updatedRow = {
      ...editableRowData,
    };

    const transactionId = editableRowData.transactionId;
    const supplierId = editableRowData.supplierId;
    const buyerId = editableRowData.buyerId;

    const payload = {
      transactionId,
      supplierId,
      buyerId,
      data: {
        date: updatedRow.date,
        description: updatedRow.description,
        category: updatedRow.category,
        amount: Number(updatedRow.amount),
      },
    };

    try {
      await dispatch(updateTransaction(payload)).unwrap();
      if (filter === "Monthly") {
        dispatch(
          getMonthlyTransactionData({
            supplierId: supplier._id,
            buyerId: userId,
          })
        );
      } else if (filter === "Last 3 Months") {
        dispatch(
          getLastThreeMonthsTransactionData({
            supplierId: supplier._id,
            buyerId: userId,
          })
        );
      } else if (filter === "Yearly") {
        dispatch(
          getYearlyTransactionData({
            supplierId: supplier._id,
            buyerId: userId,
          })
        );
      }
      setDialogOpen(false);
      setEditableRowData(null);
    } catch (error) {
      console.error("Failed to update transaction:", error);
    }
  };
const handleSearch = () => {
  const query = searchQuery.toLowerCase();
  const buyerIdToUse = user?.isTestUser ? user?.id : user?.buyerAccountId || userId;

  const payload = {
    supplierId: supplier._id,
    buyerId: buyerIdToUse,
    searchString: query,
  };

    dispatch(getAllSearchTransactions(payload));


  setViewMode("search");
  setSearchQuery("");
};


  const dataToDisplay =
      selectedOption.value === "All"
      ? transactions.slice(0, 5)
      : [];

  const handleChange = (option) => {
    setSelectedOption(option);
    setViewMode("filter");
  };

  useEffect(() => {
    if (searchQuery === "" && viewMode !== "search") {
      setViewMode("filter");
    }
  }, [searchQuery, viewMode]);

  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const handleDeleteRow = async (transactionId) => {
    const buyerIdToUse = user?.isTestUser ? user?.id : user?.buyerAccountId || userId;
    await dispatch(
      deleteTransactions({
        supplierId: supplier._id,
        buyerId: buyerIdToUse,
        transactionIds: [transactionId],
      })
    );
    if (filter === "Monthly") {
      dispatch(
        getMonthlyTransactionData({ supplierId: supplier._id, buyerId: userId })
      );
    } else if (filter === "Last 3 Months") {
      dispatch(
        getLastThreeMonthsTransactionData({
          supplierId: supplier._id,
          buyerId: userId,
        })
      );
    } else if (filter === "Yearly") {
      dispatch(
        getYearlyTransactionData({ supplierId: supplier._id, buyerId: userId })
      );
    }
    setOpenMenuIndex(null);
  };
  return (
    <>
      <div className="flex flex-col mr-4 mt-8">
        <span className="text-left text-lg font-semibold mb-4">
          Supplier Transaction Data
        </span>
        <div className="flex flex-row justify-between items-center gap-6">
          <div className="flex flex-row sm:items-center sm:justify-start gap-2 sm:gap-2 w-full sm:w-auto">
            <div
              style={{
                position: "relative",
                display: "inline-block",
                flexGrow: 1,
                minWidth: 0,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                }}
              ></svg>

              <input
                type="text"
                placeholder="Input your prompt to match your search"
                aria-label="Search"
                className="supplier-search-input pl-[35px] text-[#A8A8A8] italic font-normal w-full"
                style={{ minWidth: 0 }}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <button
              onClick={handleSearch}
              type="submit"
              className="flex items-center gap-2 px-4 py-2 text-white rounded-lg bg-[#08F] font-semibold border-none cursor-pointer whitespace-nowrap"
            >
              Search
            </button>
          </div>
          <div className="flex flex-row justify-center items-center gap-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              onClick={() => setDialogOpen(true)}
              className="cursor-pointer"
            >
              <path
                d="M0.185547 18.5V13.5H2.18555V16.5H5.18555V18.5H0.185547ZM13.1855 18.5V16.5H16.1855V13.5H18.1855V18.5H13.1855ZM0.185547 5.5V0.5H5.18555V2.5H2.18555V5.5H0.185547ZM16.1855 5.5V2.5H13.1855V0.5H18.1855V5.5H16.1855Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className="pt-6 pb-12 overflow-x-auto">
        <table className="min-w-full bg-white shadow rounded-lg">
          <thead className="text-left text-sm font-medium text-[#1D2739] border-b bg-[#F7F7F7]">
            <tr>
              {/* <th className="p-4">Transaction ID</th> */}
              <th className="p-4">Date</th>
              <th className="p-4">Description</th>
              <th className="p-4">Category</th>
              <th className="p-4">Amount</th>
              {/* <th className="p-4">Status</th> */}
              <th className="p-4"></th>
            </tr>
          </thead>
          <tbody>
            {dataToDisplay.map((txn, index) => (
              <tr className="text-sm border-b hover:bg-gray-50">
                {/* <td className="p-4">{txn.transactionId}</td> */}
                <td className="p-4 whitespace-nowrap">
                  {new Date(txn.date).toLocaleDateString("en-US")}
                </td>
                <td className="p-4">{txn.description}</td>
                <td className="p-4 border-none">
                  {txn.category ? (
                    <span className="inline-block bg-green-100 text-green-700 text-xs px-2 py-1 rounded">
                      {txn.category}
                    </span>
                  ) : (
                    <span className="text-sm text-gray-500"></span>
                  )}
                </td>
                <td className="p-4">$ {txn.amount}</td>
                <td className="relative p-4">
                  <button
                    onClick={
                      !isDialogOpen ? () => toggleMenu(index) : undefined
                    }
                    className="text-gray-500 hover:text-gray-800"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M8.9579 4.1951C9.37691 4.1951 9.71658 3.85542 9.71658 3.43642C9.71658 3.01741 9.37691 2.67773 8.9579 2.67773C8.53889 2.67773 8.19922 3.01741 8.19922 3.43642C8.19922 3.85542 8.53889 4.1951 8.9579 4.1951Z"
                        stroke="#1D2739"
                        strokeWidth="1.51736"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.9579 9.75857C9.37691 9.75857 9.71658 9.4189 9.71658 8.99989C9.71658 8.58088 9.37691 8.24121 8.9579 8.24121C8.53889 8.24121 8.19922 8.58088 8.19922 8.99989C8.19922 9.4189 8.53889 9.75857 8.9579 9.75857Z"
                        stroke="#1D2739"
                        strokeWidth="1.51736"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.9579 15.3221C9.37691 15.3221 9.71658 14.9824 9.71658 14.5634C9.71658 14.1444 9.37691 13.8047 8.9579 13.8047C8.53889 13.8047 8.19922 14.1444 8.19922 14.5634C8.19922 14.9824 8.53889 15.3221 8.9579 15.3221Z"
                        stroke="#1D2739"
                        strokeWidth="1.51736"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  {!isDialogOpen && openMenuIndex === index && (
                    <div
                      className="absolute right-4 top-10 z-1000 bg-white border rounded shadow-md w-32"
                      style={{ zIndex: 100000 }}
                    >
                      <ul className="text-sm">
                        <li
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                          onClick={() => {
                            setEditableRowData(txn);
                            setEditDialogOpen(true);
                            setOpenMenuIndex(null);
                          }}
                        >
                          <div className="flex items-center gap-2">
                            <Edit2 size={14} /> Edit
                          </div>
                        </li>
                        <li
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                          onClick={() => handleDeleteRow(txn.transactionId)}
                        >
                          <div className="flex items-center gap-2 text-red-600">
                            <Trash2 size={14} /> Delete
                          </div>
                        </li>
                      </ul>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isDialogOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 ml-24"
          onClick={() => setDialogOpen(false)}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-h-[75vh] w-[80vw] md:w-[70vw] overflow-y-auto p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex flex-row justify-between items-center mb-4">
              <h2 className="flex justify-center items-center text-xl font-semibold ">
                All Previous Spend Data
              </h2>
              <button
                onClick={() => setDialogOpen(false)}
                className="px-4 py-2 bg-[#EDEDED] rounded"
              >
                Close
              </button>
            </div>
            <table className="min-w-full bg-white shadow rounded-lg">
              <thead className="text-left text-sm font-medium text-[#1D2739] border-b bg-[#F7F7F7]">
                <tr>
                  {/* <th className="p-4 whitespace-nowrap">Transaction ID</th> */}
                  <th className="p-4">Date(MM/DD/YYYY)</th>
                  <th className="p-4">Description</th>
                  <th className="p-4">Category</th>
                  <th className="p-4">Amount</th>
                  <th className="p-4"></th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((txn, index) => (
                  <tr className="text-sm border-b hover:bg-gray-50">
                    {/* <td className="p-4">{txn.transactionId}</td> */}
                    <td className="p-4 whitespace-nowrap">
                      {new Date(txn.date).toLocaleDateString("en-US")}
                    </td>
                    <td className="p-4">{txn.description}</td>
                    <td className="p-4">
                      <span className="inline-block bg-green-100 text-green-700 text-xs px-2 py-1 rounded">
                        {txn.category}
                      </span>
                    </td>
                    {/* <td className="p-4">{txn.supplier}</td> */}
                    <td className="p-4">{txn.amount}</td>
                    <td className="relative p-4">
                      <button
                        onClick={() => toggleMenu(index)}
                        className="text-gray-500 hover:text-gray-800"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M8.9579 4.1951C9.37691 4.1951 9.71658 3.85542 9.71658 3.43642C9.71658 3.01741 9.37691 2.67773 8.9579 2.67773C8.53889 2.67773 8.19922 3.01741 8.19922 3.43642C8.19922 3.85542 8.53889 4.1951 8.9579 4.1951Z"
                            stroke="#1D2739"
                            strokeWidth="1.51736"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M8.9579 9.75857C9.37691 9.75857 9.71658 9.4189 9.71658 8.99989C9.71658 8.58088 9.37691 8.24121 8.9579 8.24121C8.53889 8.24121 8.19922 8.58088 8.19922 8.99989C8.19922 9.4189 8.53889 9.75857 8.9579 9.75857Z"
                            stroke="#1D2739"
                            strokeWidth="1.51736"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M8.9579 15.3221C9.37691 15.3221 9.71658 14.9824 9.71658 14.5634C9.71658 14.1444 9.37691 13.8047 8.9579 13.8047C8.53889 13.8047 8.19922 14.1444 8.19922 14.5634C8.19922 14.9824 8.53889 15.3221 8.9579 15.3221Z"
                            stroke="#1D2739"
                            strokeWidth="1.51736"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                      {openMenuIndex === index && (
                        <div
                          className="absolute right-4 top-10 z-1000 bg-white border rounded shadow-md w-32"
                          style={{ zIndex: 100000 }}
                        >
                          <ul className="text-sm">
                            <li
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                              onClick={() => {
                                setEditableRowData(txn);
                                setEditDialogOpen(true);
                                setOpenMenuIndex(null);
                              }}
                            >
                              <div className="flex items-center gap-2">
                                <Edit2 size={14} /> Edit
                              </div>
                            </li>
                            <li
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                              onClick={() =>
                                handleDeleteRow(txn.transactionId)
                              }
                            >
                              <div className="flex items-center gap-2 text-red-600">
                                <Trash2 size={14} /> Delete
                              </div>
                            </li>
                          </ul>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {isEditDialogOpen && editableRowData && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 ml-24"
          onClick={() => {
            setDialogOpen(false);
            setEditableRowData(null);
          }}
        >
          <div
            className="bg-white rounded-lg shadow-lg min-h-[40vh] max-h-[80vh] w-[85vw] md:w-[65vw] overflow-y-auto p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex flex-row justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Edit Transactions Data</h2>
              <button
                onClick={() => {
                  setDialogOpen(false);
                  setEditableRowData(null);
                }}
                className="px-4 py-2 bg-[#EDEDED] rounded"
              >
                Close
              </button>
            </div>

            <table className="min-w-full bg-white shadow rounded-lg">
              <thead className="text-left text-sm font-medium text-[#1D2739] border-b bg-[#F7F7F7]">
                <tr>
                  {/* <th className="p-4 whitespace-nowrap">Transaction ID</th> */}
                  <th className="p-4">Date(MM/DD/YYYY)</th>
                  <th className="p-4">Description</th>
                  <th className="p-4">Category</th>
                  <th className="p-4">Amount</th>
                  <th className="p-4"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-4 whitespace-nowrap">
                    <input
                      type="text"
                      className="w-24 p-1 border-none outline-none focus:outline-none focus:ring-0"
                      value={new Date(editableRowData.date).toLocaleDateString(
                        "en-US"
                      )}
                      onChange={(e) =>
                        setEditableRowData({
                          ...editableRowData,
                          date: e.target.value,
                        })
                      }
                    />
                  </td>
                  <td className="p-4">
                    <input
                      type="text"
                      className="w-full p-1 border-none outline-none focus:outline-none focus:ring-0"
                      value={editableRowData.description}
                      onChange={(e) =>
                        setEditableRowData({
                          ...editableRowData,
                          description: e.target.value,
                        })
                      }
                    />
                  </td>
                  <td className="p-4">
                    <input
                      type="text"
                      className="w-full p-1 border-none outline-none focus:outline-none focus:ring-0"
                      value={editableRowData.category}
                      onChange={(e) =>
                        setEditableRowData({
                          ...editableRowData,
                          category: e.target.value,
                        })
                      }
                    />
                  </td>
                  <td className="p-4">
                    <input
                      type="text"
                      className="w-24 p-1 border-none outline-none focus:outline-none focus:ring-0"
                      value={editableRowData.amount}
                      onChange={(e) =>
                        setEditableRowData({
                          ...editableRowData,
                          amount: e.target.value,
                        })
                      }
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="flex justify-end items-end mt-12 ">
              <button
                className="px-4 py-1 bg-[#EAF524] text-black rounded"
                onClick={handleUpdateTransaction}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
